import React, { useState, useEffect } from "react";
import { Plus, Edit, Trash } from "lucide-react";
import { useNavigate } from "react-router-dom";
import apiService from "../../services/apiService";
import { toast } from "react-toastify";

const RadioFile = () => {
  const navigate = useNavigate();
  const [Slot, setSlot] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedslotId, setSelectedslotId] = useState(null);
  const [offset, setOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const limit = 20;

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      fetchRadioFile();
    } else {
      navigate("/");
    }
  }, [navigate, offset]);

  const fetchRadioFile = async () => {
    try {
      const response = await apiService.postData("admin/radio-file-path-list", 
        {
        // limit,
        // offset, 
      }
    );
    if (response?.data) {
      setSlot(response.data);
      setTotalCount(response.data.length);
    }  
     } catch (error) {
      console.error("Error fetching Slot:", error);
    }
  };

  const handleEdit = (slotId) => navigate(`/radio/file/edit-file/${slotId}`);

  const openModal = (slotId) => {
    setSelectedslotId(slotId);
    setIsModalOpen(true);
  };

  const handleDelete = async () => {
    if (selectedslotId) {
      try {
        await apiService.deleteData(`admin/radio-file-path/${selectedslotId}`);
        setIsModalOpen(false);
        setSelectedslotId(null);
        fetchRadioFile();
      } catch (error) {
        console.error("Error deleting slot:", error);
      }
    }
  };

  const totalPages = Math.ceil(totalCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;
  const renderPagination = () => {
    const pageButtons = [];
    const maxButtons = 5;
    const halfRange = Math.floor(maxButtons / 2);

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) {
        pageButtons.push(i);
      }
    } else {
      let startPage = Math.max(1, currentPage - halfRange);
      let endPage = Math.min(totalPages, currentPage + halfRange);

      if (startPage > 1) pageButtons.push(1);
      if (startPage > 2) pageButtons.push("...");

      for (let i = startPage; i <= endPage; i++) {
        pageButtons.push(i);
      }

      if (endPage < totalPages - 1) pageButtons.push("...");
      if (endPage < totalPages) pageButtons.push(totalPages);
    }

    return pageButtons.map((page, index) =>
      typeof page === "number" ? (
        <button
          key={index}
          className={`btn mx-1 ${currentPage === page ? "btn-primary" : "btn-outline-primary"}`}
          onClick={() => setOffset((page - 1) * limit)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="btn mx-1 disabled">
          {page}
        </span>
      )
    );
  };


  return (
    <div className="container">
      <div className="card">
        <div className="card-header d-flex justify-content-between">
          <h4>Radio File</h4>
          <button
onClick={() => navigate("new-radio")}
className="btn btn-primary"
          >
            Add Radio File <Plus size={16} />
          </button>
        </div>
        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-bordered">
            <thead>
                <tr>
                  <th>File Path</th>
                  <th>Audio</th>
                  <th>Duration in seconds</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {Slot.map((item) => (
                  <tr key={item.radio_audio_file_id}>
                    <td>{item.file_path || "-"}</td>
                                                            <td>
                                                              {item.file_path ? (
                                                                <audio controls className="mt-1">
                                                                  <source
                                                                    src={apiService.getAudioRadioUrl(item.file_path)}
                                                                    type="audio/mp3"
                                                                  />
                                                                  Your browser does not support the audio element.
                                                                </audio>
                                                              ) : (
                                                                "No Audio"
                                                              )}
                                                            </td>
                    <td>{item.duration || "-"}</td>
                    <td>
                      <div className="dropdown">
                        <button
                          className="btn btn-outline-primary btn-sm dropdown-toggle"
                          type="button"
                          id={`dropdownMenuButton${item.radio_audio_file_id}`}
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                        >
                          Action
                        </button>
                        <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${item.radio_audio_file_id}`}>
                          {/* <li>
                            <button className="dropdown-item" onClick={() => handleEdit(item.radio_audio_file_id)}>
                              <Edit size={14} className="me-2" />
                              Edit
                            </button>
                          </li> */}
                          <li>
                            <button className="dropdown-item text-danger" onClick={() => openModal(item.radio_audio_file_id)}>
                              <Trash size={14} className="me-2" />
                              Delete
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <nav className="d-flex justify-content-center my-3">
        <button
          className="btn btn-outline-primary me-2"
          onClick={() => setOffset(offset - limit)}
          disabled={offset === 0}
        >
          «
        </button>
        {renderPagination()}
        <button
          className="btn btn-outline-primary ms-2"
          onClick={() => setOffset(offset + limit)}
          disabled={offset + limit >= totalCount}
        >
          »
        </button>
      </nav>
      </div>

      {isModalOpen && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Deletion</h5>
                <button type="button" className="btn-close" onClick={() => setIsModalOpen(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this slot?</p>
              </div>
              <div className="modal-footer">
                <button className="btn btn-danger" onClick={handleDelete}>Yes</button>
                <button className="btn btn-secondary" onClick={() => setIsModalOpen(false)}>No</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RadioFile;
